import { Inject, Injectable } from '@angular/core';
import { Analytics } from '@services/analytics.service';
import { Angulartics2 } from 'angulartics2';

import { WINDOW } from 'src/app/app.module';

@Injectable({
  providedIn: 'root'
})
export class ClarityService implements Analytics {
  clarity: any;

  constructor(private angulartics2: Angulartics2, @Inject(WINDOW) private window: Window) {
    this.clarity = window?.['clarity'];
    if (this.clarity) {
      this.angulartics2.setUsername.subscribe((id) => {
        this.clarity('identify', id);
        this.clarity('set', 'RapidID', id);
      });
    }
  }

  startTracking() {
    if (this.clarity) {
      this.clarity('consent');
    }
  }
}
